import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';

const STORAGE_KEY = 'makhe.cookieConsent.v1';

interface Consent {
  essential: true;
  analytics: boolean;
  errorReporting: boolean;
  decidedAt: string;
}

export function getCookieConsent(): Consent | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as Consent) : null;
  } catch {
    return null;
  }
}

export function CookieBanner() {
  const [consent, setConsent] = useState<Consent | null>(() => getCookieConsent());
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!consent) setOpen(true);
  }, [consent]);

  if (!open) return null;

  const save = (analytics: boolean, errorReporting: boolean) => {
    const next: Consent = {
      essential: true,
      analytics,
      errorReporting,
      decidedAt: new Date().toISOString(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    setConsent(next);
    setOpen(false);
  };

  return (
    <div
      role="dialog"
      aria-label="Cookie preferences"
      className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-xl rounded-lg border border-makhe-line bg-makhe-surface p-5 shadow-lift animate-rise md:bottom-5"
    >
      <p className="eyebrow">A small note</p>
      <p className="mt-2 text-sm leading-relaxed text-makhe-ink/85">
        We use essential cookies to keep you signed in. We'd like to use analytics &amp;
        error reporting so we can improve Makhe.{' '}
        <Link to="/legal/cookie-policy" className="underline underline-offset-4 hover:text-makhe-primary">
          Read more
        </Link>
        .
      </p>
      <div className="mt-4 flex flex-wrap gap-2">
        <Button size="sm" variant="ink" onClick={() => save(true, true)}>
          Accept all
        </Button>
        <Button size="sm" variant="secondary" onClick={() => save(false, false)}>
          Essential only
        </Button>
      </div>
    </div>
  );
}
